import React, { useState, useEffect, useMemo, JSXElementConstructor, Key, ReactElement } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Router, useThemeProvider, usePluginProvider } from '@cloudpremise/portal_core';
import { routes, footerRoutes } from '../routes';
import menus from "../menus";
import MDBox from "@cloudpremise/portal_core/src/themes/mui/components/MDBox";
import NavbarTransparent from "@cloudpremise/portal_core/src/themes/mui/components/Navbars/NavbarTransparent";
import DefaultFooter from "@cloudpremise/portal_core/src/themes/mui/examples/Footers/DefaultFooter";

// @mui material components
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import Icon from "@mui/material/Icon";

// Material Dashboard 2 PRO React TS contexts
import { useMaterialUIController, setMiniSidenav, setOpenConfigurator } from "@cloudpremise/portal_core/src/themes/mui/context";
import Sidenav from "@cloudpremise/portal_core/src/themes/mui/examples/Sidenav";
import Configurator from "@cloudpremise/portal_core/src/themes/mui/examples/Configurator";
import themeDark from "@cloudpremise/portal_core/src/themes/mui/assets/theme-dark";
import theme from "@cloudpremise/portal_core/src/themes/mui/assets/theme";
import LeadModal from "../components/LeadModal";

// RTL plugins
import createCache from "@emotion/cache";

import Config from "../Config";
const cdnUrl = Config.getCdnUrl();

// Images
const brandWhite = cdnUrl + "/assets/images/logo-ct.png";
const brandDark = cdnUrl + "/assets/images/logo-ct-dark.png";
const bgImage = cdnUrl + "/assets/img/main_banner.jpg";


function CustomRouter({page, basename, history}){
    const [controller, dispatch] = useMaterialUIController();
    const {
        miniSidenav,
        direction,
        layout,
        openConfigurator,
        sidenavColor,
        transparentSidenav,
        whiteSidenav,
        darkMode,
    } = controller;
    const [onMouseEnter, setOnMouseEnter] = useState(false);
    const { pathname } = useLocation();
    const pluginManager = usePluginProvider();
    const [leadModal, onLeadModal] = useState(false);
    const footerroutes = footerRoutes({
      page: page,
      basename: basename,
      history: history,
      onLeadModal: onLeadModal
    });

  // Open sidenav when mouse enter on mini sidenav
  const handleOnMouseEnter = () => {
    if (miniSidenav && !onMouseEnter) {
      setMiniSidenav(dispatch, false);
      setOnMouseEnter(true);
    }
  };

  // Close sidenav when mouse leave mini sidenav
  const handleOnMouseLeave = () => {
    if (onMouseEnter) {
      setMiniSidenav(dispatch, true);
      setOnMouseEnter(false);
    }
  };

  // Change the openConfigurator state
  const handleConfiguratorOpen = () => setOpenConfigurator(dispatch, !openConfigurator);

  // Setting the dir attribute for the body element
  useEffect(() => {
    document.body.setAttribute("dir", direction);
  }, [direction]);

  // Setting page scroll to 0 when changing the route
  useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
  }, [pathname]);

  let routeKey = 0;
  const getRoutes = (allRoutes: any[]): any =>
    allRoutes.map(
      (route: {
        collapse: any;
        route: string;
        component: ReactElement<any, string | JSXElementConstructor<any>>;
        key: Key;
      }) => {
        if (route.collapse) {
          return getRoutes(route.collapse);
        }

        if (route.route) {
          routeKey++;
          return <Route path={route.route} element={route.component} key={routeKey} />;
        }

        return null;
      }
    );

    const configsButton = (
        <MDBox
          display="flex"
          justifyContent="center"
          alignItems="center"
          width="3.25rem"
          height="3.25rem"
          bgColor="white"
          shadow="sm"
          borderRadius="50%"
          position="fixed"
          right="2rem"
          bottom="2rem"
          zIndex={99}
          color="dark"
          sx={{ cursor: "pointer" }}
          onClick={handleConfiguratorOpen}
        >
          <Icon fontSize="small" color="inherit">
            settings
          </Icon>
        </MDBox>
    );

    const pluginUserMenus = pluginManager.getUserMenus();
    let routesList = routes({page, basename, history});
    let menusList =  menus({pluginUserMenus: pluginUserMenus, page: page, basename: basename, history: history});
    const pluginRoutes = pluginManager.getRoutes({page, basename, history});
    routesList = routesList.concat(pluginRoutes);
    const pluginMenus = pluginManager.getMenus();
    menusList = menusList.concat(pluginMenus);
    const logo = cdnUrl+"/assets/img/logo.png";
    // const logo = (
    //     <svg preserveAspectRatio="xMidYMid meet" data-bbox="20 46 160 108" xmlns="http://www.w3.org/2000/svg" height="40" width="40" viewBox="20 46 160 108" role="presentation">
    //         <g fill-rule="evenodd">
    //             <path fill="#224568" d="M143.509 123.081V154H53.684v-30.919h89.825z"></path>
    //             <path fill="#224568" d="M180 118.865C180 138.27 164.29 154 144.912 154c-19.379 0-35.088-15.73-35.088-35.135 0-19.405 15.71-35.135 35.088-35.135 19.379 0 35.088 15.73 35.088 35.135z"></path>
    //             <path fill="#224568" d="M90.176 118.865c0 19.405-15.71 35.135-35.088 35.135C35.709 154 20 138.27 20 118.865 20 99.46 35.71 83.73 55.088 83.73c19.379 0 35.088 15.73 35.088 35.135z"></path>
    //             <path fill="#224568" d="M140.701 88.162c0 23.285-18.851 42.162-42.105 42.162-23.254 0-42.105-18.877-42.105-42.162S75.342 46 98.596 46c23.254 0 42.105 18.877 42.105 42.162z"></path>
    //         </g>
    //     </svg>
    // )
    
    return (
        <>
            <CssBaseline />
            <Router
                routes={routesList}
                header={
                    (
                      <div className="header-container header-olympusgrid">
                        <NavbarTransparent
                            routes={menusList}
                            action={{
                                type: "internal",
                                href: "javascript:void(0);",
                                label: "Contact Us",
                                color: "warning",
                                onClick: () => {
                                  onLeadModal(!leadModal);
                                }
                            }}
                            // transparent
                            sticky
                            relative
                            light
                            logo={logo}
                            history={history}
                            page={page}
                            basename={basename}
                        />
                      </div>
                    )
                }
                footer={
                    (
                        <MDBox className="footer-container">
                            <DefaultFooter content={footerroutes} />
                        </MDBox>
                    )
                }
            />
            {
              leadModal ?
                <LeadModal
                  open={leadModal}
                  onCancel={() => {onLeadModal(!leadModal);}}
                  onSuccess={() => {onLeadModal(!leadModal);}}
                />
              :
                null
            }
        </>
    );

}

export default CustomRouter;